import { Feature, Menu } from '@mairistem/module';
import { MENUS } from '@/constants';
import { LoadingContextProvider, ModeReglementContextProvider } from '../Context';
import EncaissementDirect from './EncaissementDirect';

const MenuEncaissementDirect = () => (
  <Menu
    code={MENUS.MENU_ENCAISSEMENT_DIRECT}
    name="Encaissement direct"
    icon="euro"
    path="/encaissement-direct"
  >
    <Feature>
      <Feature.Content>
        <LoadingContextProvider>
          <ModeReglementContextProvider>
            <EncaissementDirect />
          </ModeReglementContextProvider>
        </LoadingContextProvider>
      </Feature.Content>
    </Feature>
  </Menu>
);

export default MenuEncaissementDirect;
